var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "시설 자체점검 목록",
          tableId: "facilitySelfCheckWeeksPop",
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          gridHeight: "500px",
          filtering: false,
          columnSetting: false,
          usePaging: false,
        },
        on: { linkClick: _vm.linkClick },
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }